import { render, staticRenderFns } from "./logisticsDetail.vue?vue&type=template&id=6680927a&scoped=true&"
import script from "./logisticsDetail.vue?vue&type=script&lang=js&"
export * from "./logisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./logisticsDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./logisticsDetail.vue?vue&type=style&index=1&id=6680927a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6680927a",
  null
  
)

export default component.exports